import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import MultiformDictionaries from '@/modules/multiForm/shared/MultiformDictionaries';
import {FFIncome} from '@/models/ExpertState';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import { IMultiformDictionaryElement } from '@/modules/multiForm/shared/IMultiformDictionary';
import {FFIncomeType} from '@/modules/multiForm/shared/Types';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
type IncomeSourcesListType = Array<IMultiformDictionaryElement<FFIncomeType> | {header: string} | {divider: boolean}>;

export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationFormStep2IncomeSource',
  props: {
    income: null
  },
  setup(__props: any) {

const props = __props as {
  income: FFIncome
}

const store = useSimulationStore();



const MIN_INCOME_DURATION = 1;
const MAX_INCOME_DURATION = computed(() => { return store.isCash ? 36 : 48 });
const fill = (length: number) => Array.from({length,});

const incomeCashPeriodTickLabels = [...fill(2), `3${I18NGetter().useSimulationFormStep2IncomeSource.MC}`,
  ...fill(2), `6${I18NGetter().useSimulationFormStep2IncomeSource.MCY}`,
  ...fill(5), `12${I18NGetter().useSimulationFormStep2IncomeSource.MCY}`,
  ...fill(11), `2 ${I18NGetter().useSimulationFormStep2IncomeSource.YEARS}`,] as const;

const incomeMortgagePeriodTickLabels = [
  ...fill(2), '3m',
  ...fill(2), '6m',
  ...fill(5), '12m',
  ...fill(11), `2 ${I18NGetter().useSimulationFormStep2IncomeSource.YEARS}`,
  ...fill(23), `4+ ${I18NGetter().useSimulationFormStep2IncomeSource.YEARS}`,] as const;

const incomePeriodTickLabels = computed(() => {
  return store.isCash ? incomeCashPeriodTickLabels : incomeMortgagePeriodTickLabels
})

const availableIncomeSources = computed<IncomeSourcesListType>(() => {
  return [
    {header: I18NGetter().useSimulationFormStep2IncomeSource.CONTRACT_OF_EMPLOYMENT_CONTRACT_ORDER,},
    {divider: true,},
    ...MultiformDictionaries.contractIncomeTypes,
    {header: I18NGetter().useSimulationFormStep2IncomeSource.CONTRACT,},
    {divider: true,},
    ...MultiformDictionaries.otherContractIncomeTypes,
    {header: I18NGetter().useSimulationFormStep2IncomeSource.BUSINESS,},
    {divider: true,},
    ...MultiformDictionaries.businessIncomeTypes,
    {header: I18NGetter().useSimulationFormStep2IncomeSource.ABROAD_INCOME,},
    {divider: true,},
    ...MultiformDictionaries.abroadIncomeTypes,
    {header: I18NGetter().useSimulationFormStep2IncomeSource.RETIREMENT_INCOME,},
    {divider: true,},
    ...MultiformDictionaries.retirementIncomeTypes,
    {header: I18NGetter().useSimulationFormStep2IncomeSource.OTHER,},
    {divider: true,},
    ...MultiformDictionaries.otherIncomeTypes,
  ];
});

const resetIncomeValues = () => {
  if (props.income) {
    delete props.income.threeMonthsAverage
    delete props.income.sixMonthsAverage;
    delete props.income.twelveMonthsAverage
    delete props.income.currentYearIncome
    delete props.income.currentYearCost
  }
};


return { __sfc: true,store, props, MIN_INCOME_DURATION, MAX_INCOME_DURATION, fill, incomeCashPeriodTickLabels, incomeMortgagePeriodTickLabels, incomePeriodTickLabels, availableIncomeSources, resetIncomeValues, I18NGetter, FFIncomeType }
}

})